import WorkItemDetail from '~/work_items/components/work_item_detail.vue';
import ImplementationWidget from 'ee/work_items/components/implementation_widget/implementation_widget.vue';
import WorkplanStickyHeaderQuestions from 'ee/work_items/components/implementation_widget/workplan_sticky_header_questions.vue';
import WorkItemDecisionLog from 'ee/work_items/components/decision_log/work_item_decision_log.vue';
import WorkItemAgentSessions from 'ee/work_items/components/agent_sessions/index.vue';
import WorkItemPlanCta from 'ee/work_items/components/work_item_plan_cta.vue';
import { WORKPLAN_PANEL, DECISION_LOG_PANEL } from '~/work_items/constants';
import { findDecisionLogWidget, isAgentPlanEnabled } from 'ee/work_items/utils';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'WorkItemDetailEE',
    WORKPLAN_PANEL,
    DECISION_LOG_PANEL,
    components: {
        WorkItemDetail,
        ImplementationWidget,
        WorkItemAgentSessions,
        WorkItemDecisionLog,
        WorkItemPlanCta,
        WorkplanStickyHeaderQuestions
    },
    mixins: [
        glFeatureFlagsMixin(),
        glListenersMixin
    ],
    inheritAttrs: false,
    methods: {
        isAgentPlanAvailable (workItem) {
            return isAgentPlanEnabled(workItem);
        },
        showDecisionLog (workItem) {
            return Boolean(this.glFeatures?.decisionLog) && Boolean(findDecisionLogWidget(workItem));
        },
        // Nothing pushes the open questions count, so answering a question refetches it here,
        // where both the discussion and the Workplan widget are rendered.
        refetchWorkplan () {
            this.$refs.implementationWidget?.refetchWorkplan();
        },
        showPlanCta ({ editMode, canUpdate, agentPlanWidget }) {
            return !editMode && canUpdate && Boolean(agentPlanWidget) && !agentPlanWidget.aiPlanningEnabled;
        }
    }
};
